import { API_BASE_URL } from "@/core/services/api.service";

export const GET_INT_BASE_URL = "getInterfaceBaseUrl";

export default {
    state: {
      baseUrl: API_BASE_URL
    },
    getters: {
        getInterfaceBaseUrl(state) {
            return state.baseUrl;
          },
    }
  };
  